// extracted by mini-css-extract-plugin
export default {"headingWrapper":"SocialProof__headingWrapper-F52Q","callToActionWrapper":"SocialProof__callToActionWrapper-BA7u","recentSalesWrapper":"SocialProof__recentSalesWrapper-O4TE"};